import styled from 'styled-components';
import { colors } from '../../theme/color';
import { fontSize } from '../../theme/Typography';
import React from 'react';
import { Path } from '../../routes/components/path';
import { IconProps } from '../../icons/Icon';
import { usePathname } from 'next/navigation';
import LinkNoPrefetch from '../linkNoPrefetch/LinkNoPrefetch';

type Props = {
  label: string;
  path: Path;
  icon: React.ReactElement<IconProps>;
  iconActive: React.ReactElement<IconProps>;
};

export const NavigationItem: React.FC<Props> = ({ label, path, icon, iconActive }) => {
  const pathname = usePathname();

  const isSelected = pathname === path;

  return (
    <NavigationItemContainer href={path} aria-current={isSelected ? 'page' : false}>
      <IconWrapper>{isSelected ? iconActive : icon}</IconWrapper>
      <NavigationItemName selected={isSelected}>{label}</NavigationItemName>
    </NavigationItemContainer>
  );
};

const NavigationItemContainer = styled(LinkNoPrefetch)`
  text-decoration: none;
  -webkit-tap-highlight-color: transparent;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${colors.brandDarkGreen};
`;

const IconWrapper = styled.div`
  width: 32px;
  height: 32px;

  & > svg {
    width: 100%;
    height: 100%;
  }
`;

const NavigationItemName = styled.span<{ selected: boolean }>`
  margin-top: 4px;
  color: ${colors.brandDarkGreen};
  font-family: ${({ theme }) => theme.fontFamily?.body};
  font-size: ${fontSize.SMALL_MINUS};
  font-weight: ${({ selected }) => (selected ? 800 : 500)};
`;
